import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@h2/ui';
import { useConfigurationStore } from '../../stores/useConfigurationStore';
import { ConfigurationSection } from './ConfigurationSection';

export const ConfigurationScroll: React.FC = () => {
  const { activeConfiguration } = useConfigurationStore();

  if (!activeConfiguration) {
    return <div>설정을 불러오는 중...</div>;
  }

  return (
    <div className="space-y-6">
      {activeConfiguration.sections.map((section, index) => (
        <Card key={section.id} id={`section-${section.id}`}>
          <CardHeader>
            <CardTitle>{section.title}</CardTitle>
            {section.description && (
              <CardDescription>
                {section.description}
              </CardDescription>
            )}
          </CardHeader>
          
          <CardContent>
            <ConfigurationSection section={section} hideTitle={true} />
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
